import { helpers } from '../helpers.js';

var countLines = {
    selector: {
        element: '[data-count-lines]',
        item: '[data-count-lines-item]',
        target: '[data-count-lines-target]',
    },
    init: function () {
        var self = this;

        $(self.selector.element).each(function () {
            var $el = $(this),
                columns = $el.data('count-lines'),
                $items = $el.find(self.selector.item);

            self.recalculate($items, columns);

            $(window).on(
                'resize',
                helpers.debounce(function () {
                    self.recalculate($items, columns);
                }, 200)
            );
        });
    },
    recalculate: function ($items, columns) {
        var self = this;
        var i, j, tempArray;

        for (i = 0, j = $items.length; i < j; i += columns) {
            tempArray = $items.slice(i, i + columns);
            var maxLength = 1;

            tempArray.each(function () {
                var target = this.querySelector(self.selector.target),
                    rects = target.getClientRects(),
                    rectsLength = rects.length;

                if (rectsLength > maxLength) {
                    maxLength = rectsLength;
                }
            });

            tempArray.removeClass(function (index, className) {
                return (className.match(/(^|\s)lines-\S+/g) || []).join(' ');
            });

            tempArray.addClass('lines-' + maxLength);
        }
    },
};

export { countLines };
